<template>
    <div>
        <Banner class="d-block d-sm-block d-md-block d-lg-none d-xl-none" />
        <Banner class="d-none d-sm-none d-md-none d-lg-block d-xl-block" :bannerMessage="bannerMessage" />
        <div class="container">
            <DownloadRewardsCard :Heading="Heading"
                                 :ThanksForJoininDevice="ThanksForJoininDevice"
                                 :ThanksForJoininMobile="ThanksForJoininMobile"
                                 :appleWallet="appleWallet"
                                 :googlePay="googlePay"
                                 :cardNumber="cardNumber"
                                 :jwtGoogle="jwtGoogle"
                                 :customerName="customerName"
                                 :tier="tier"
                                 :customerId="customerId"
                                 :carduid="carduid"
                                 :flagLog="flagLog" />
            <p class="text pt-5">
                Finished downloading your digital Rewards card?
                <span @click="signOut" class="hyperlink">Sign Out</span>
            </p>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import DownloadRewardsCard from '@/components/DownloadRewardsCard.vue'
    import Banner from '@/components/Banner.vue'
    import digitalApi from '@/services/DigitalApiClient.js'
    import idle from '@/services/Idle.js'
    import gigyaWebSDK from '@/gigyaWebSDK'
    import { useStore } from 'vuex'

    const router = useRouter()
    const store = useStore()

    const bannerMessage = ref('')
    const appleWallet = ref('@/assets/Add_to_Apple_Wallet_rgb_US-UK.svg')
    const googlePay = ref('@/assets/Save to Google Pay - English (Dark).svg')
    const cardNumber = ref('')
    const customerName = ref('')
    const tier = ref('')
    const customerId = ref('')
    const jwtGoogle = ref('')
    const carduid = ref('')
    const flagLog = ref('S')
    const isMyBeauty = ref(false)

    const Heading = computed(() => 'Download your digital Rewards card')
    const ThanksForJoininDevice = computed(() =>
        isMyBeauty.value
            ? 'An email containing all your account details will be with you very soon. Click the button below to download your digital Rewards card to your phone.'
            : 'Click the button below to download your digital Rewards card. You will then need to send it to your mobile device to be able to use it.'
    )
    const ThanksForJoininMobile = computed(() =>
        isMyBeauty.value
            ? 'An email containing all your account details will be with you very soon. Click the button below to download your digital Rewards card to your phone.'
            : 'Click the button below to download your digital Rewards card to your phone.'
    )

    function signOut() {
        gigyaWebSDK.accounts.session.verify({
            callback: function (response) {
                if (response.errorCode == 0) {
                    const params = {
                        callback: function () {
                            digitalApi
                                .clearUser()
                                .then(function () {
                                    router.push({ path: `/` })
                                    store.dispatch('reset')
                                })
                                .catch(function (error) {
                                    console.log(error)
                                    router.push({ path: `/` })
                                })
                        }
                    }
                    gigyaWebSDK.accounts.logout(params)
                } else {
                    store.dispatch('reset')
                    router.push({ path: `/` })
                }
            }
        })
    }

    onMounted(() => {
        digitalApi.getUser().then((result) => {
            if (result.isRewards === false) {
                router.push({ name: 'JoinRewardsHome', params: { user: result } })
            } else if (result.email != null && result.email !== '') {
                isMyBeauty.value = result.isMyBeautyMember
                cardNumber.value = result.cardNumber
                customerName.value = result.firstName + ' ' + result.lastName
                tier.value = result.tier
                customerId.value = result.id
                carduid.value = result.carduid

                digitalApi.getGoogleCardToken(result.id).then((token) => {
                    jwtGoogle.value = token
                    let c
                    c = setTimeout(function () {
                        clearTimeout(c)
                        idle()
                    }, 500)
                })
            } else {
                router.push({ name: 'SignInToRewards' })
            }
        }).catch((error) => {
            console.log(error)
            router.push({ name: 'SignInToRewards' })
            // Optionally: appInsights.trackException({exception: error});
        })
    })
</script>

<style lang="scss" scoped>
.banner {

  @media screen and (max-width: 767px) and (min-width: 0px) {
    height: 187px !important;
    padding: 30px 30px;
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    height: 338px !important;
  }
}
</style>
